// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__UaQZl","subheader":"ReorderModal_subheader__294xC","listWrap":"ReorderModal_listWrap__36aSO"};